import { Component, inject, model } from '@angular/core';
import { BranchesService } from '../services/branches.service';
import { BranchModel } from '../../shared/models/branch.model';
import { ActivatedRoute } from '@angular/router';
import { BranchesFormComponent } from "../branches-form/branches-form.component";
import { AccessService } from '../../core/services/access.service';

@Component({
  selector: 'app-branches-delete',
  standalone: true,
  imports: [BranchesFormComponent],
  templateUrl: './branches-delete.component.html',
  styleUrl: './branches-delete.component.css'
})
export class BranchesDeleteComponent {
  private route = inject(ActivatedRoute)
  private service = inject(BranchesService)

  protected access = inject(AccessService).access
  protected id!: string | null;

  protected value = model<BranchModel | undefined>(undefined)
  constructor() {}
  ngOnInit(): void {
    this.service.title.update((value) => 'Dealles de la Sucursal')
    this.route.paramMap.subscribe(params => {
      this.id = params.get('id');
      this.getBranch(params.get('id'));
    });
  }

  getBranch(branchId: string | null) {
    console.log('getContract', branchId)
    if (branchId === null) {
      this.value.update((value) => (value = undefined));
    } else {
      // this.userService.userDetailed(userId);
      this.service.delete(branchId).subscribe(data => {
        this.value.update((value) => (value = data as BranchModel));
      });
    }
  }
}
